import { SET_MEALS_LIST } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getMeals = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meals`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_MEALS_LIST, payload: response.data.meals });
    }
    catch (error) { errorHandler(error, null); }
};